import "./index.scss";

const EmptyState = ({ type = "no-results", icon, title, subtitle }) => {
  return (
    <div className="empty-state">
      <div className={`empty-state__card empty-state__card--${type}`}>
        <img src={icon} alt={title} className="empty-state__icon" />
        <h5 className="empty-state__title">{title}</h5>
        {subtitle && <p className="empty-state__subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default EmptyState;
